import { memo } from 'react';
import { UserRound } from 'lucide-react';
import { MessageBubble } from './MessageBubble';
import { TypingIndicator } from './TypingIndicator';

const ChatMessagesComponent = ({ activeUseCase, messages, isTyping, copiedId, setCopiedId, handleTryAgain, handleEdit, messagesEndRef, darkMode }) => {
  const hasMessages = (messages?.length || 0) > 0;
  const workspaceName = activeUseCase?.useCaseName || 'your workspace';

  return (
  <div className="flex-1 overflow-y-auto px-3 sm:px-4 pb-40 sm:pb-36 pt-16 sm:pt-20 relative z-0 hide-scrollbar bg-[#e8edf3] dark:bg-slate-900">
    <div className={`${hasMessages ? 'space-y-3 sm:space-y-4' : ''} max-w-4xl mx-auto`}>
      {!hasMessages && !isTyping && (
        <div className="min-h-[55vh] flex items-center justify-center px-4">
          <div className="text-center">
            <div className="mx-auto w-20 h-20 rounded-full bg-gradient-to-br from-[#1d57a5] to-[#36a852] flex items-center justify-center shadow-[0_10px_24px_rgba(29,87,165,0.25)]">
              <UserRound size={28} className="text-white" />
            </div>
            <h2 className="mt-6 text-3xl font-bold text-slate-800 dark:text-white">
              {workspaceName}
            </h2>
            <p className="mt-3 text-lg text-slate-600 dark:text-slate-300 max-w-xl mx-auto">
              I&apos;m connected to {workspaceName}. How can I help you?
            </p>
          </div>
        </div>
      )}
      {hasMessages && messages.map((msg) => (
        <MessageBubble key={msg.messageId} msg={msg} copiedId={copiedId} setCopiedId={setCopiedId} handleTryAgain={handleTryAgain} handleEdit={handleEdit} darkMode={darkMode} />
      ))}
      {isTyping && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  </div>
)};

export const ChatMessages = memo(ChatMessagesComponent);
